/**
 * Precast one-shot launcher tools (BIM: Precast > Fabrication / Configuration)
 *
 * These tools complete their work at activation: they open the corresponding
 * Precast dialog through the shared ManageDialogsHost pattern (same flow as
 * ProjectUnitsTool / SnapsTool) and immediately return the viewport to Select.
 */
import { BaseTool } from '../BaseTool';

/** Configuration dialog launcher (rule center for all precast automation). */
export class PrecastConfigurationTool extends BaseTool {
    id = 'precast_configuration';
    name = 'Precast Configuration';
    cursor = 'default';

    protected onActivate(): void {
        this.context?.appStore.openManageDialog('precastConfig');
        this.context?.appStore.setActiveTool('select');
    }
    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Shop Drawings dialog launcher (Fabrication > Shop Drawings). */
export class PrecastShopDrawingsTool extends BaseTool {
    id = 'precast_shop_drawings';
    name = 'Precast Shop Drawings';
    cursor = 'default';

    protected onActivate(): void {
        this.context?.appStore.openManageDialog('precastShopDrawings');
        this.context?.appStore.setActiveTool('select');
    }
    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** CAM Export dialog launcher (Fabrication > CAM Export). */
export class PrecastCamExportTool extends BaseTool {
    id = 'precast_cam_export';
    name = 'Precast CAM Export';
    cursor = 'default';

    protected onActivate(): void {
        this.context?.appStore.openManageDialog('precastCamExport');
        this.context?.appStore.setActiveTool('select');
    }
    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
